import { render } from "./VideoErrorComponent.vue?vue&type=template&id=e0522788&scoped=true"
import script from "./VideoErrorComponent.vue?vue&type=script&lang=ts"
export * from "./VideoErrorComponent.vue?vue&type=script&lang=ts"

import "./VideoErrorComponent.vue?vue&type=style&index=0&id=e0522788&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e0522788"

export default script